const LAST_C0_CONTROL_CODE = 0x1f
const DELETE_CODE = 0x7f
const TRAVERSAL_SEGMENTS = ['.', '..']

// Matches KnowledgeArticle.slug in shared/schemas/support/knowledge-article-schemas.ts.
export const MAX_ARTICLE_SLUG_LENGTH = 255

export const hasControlChars = (value: string): boolean =>
  [...value].some((char) => {
    const code = char.charCodeAt(0)
    return code <= LAST_C0_CONTROL_CODE || code === DELETE_CODE
  })

/**
 * KnowledgeArticle.slug is only `z.string().min(1).max(255)`, and the revision-approval flow
 * writes `proposedSlug` verbatim, so slugs are not guaranteed to be kebab-case. Anything that
 * survives as a single path segment is therefore accepted and percent-encoded on the way out,
 * rather than pattern-matched against a shape the backend never enforced.
 */
export const isValidArticleSlug = (value: string | null | undefined): value is string => {
  if (!value || value.length > MAX_ARTICLE_SLUG_LENGTH) {
    return false
  }
  if (hasControlChars(value)) {
    return false
  }
  if (TRAVERSAL_SEGMENTS.includes(value)) {
    return false
  }

  return !value.includes('/') && !value.includes('\\')
}
